module.exports = __webpack_public_path__ + "img/corporate.1da35e15.jpg";